<template>
    <v-dialog v-model="dialog" max-width="1300px" persistent @keydown.esc="chiudiDialog()">
        <v-card>
            <v-card-title class="headline">
                <v-col>
                    <v-row>
                        Declassamento materiale a magazzino
                        <v-spacer />
                        <v-btn icon @click="chiudiDialog()">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-row>
                    <v-row>
                        <small>Nota: solo le righe selezionate ed evidenziate di rosso verranno declassate</small>
                        <v-spacer />
                        <v-text-field v-model="search" append-icon="search" label="Cerca" single-line clearable />
                        <v-btn icon @click="caricaDati()" class="ml-2 mt-4">
                            <v-icon>refresh</v-icon>
                        </v-btn>
                    </v-row>
                </v-col>
            </v-card-title>

            <v-card-text>
                <v-data-table :items="elencoMateriali" :headers="headersMateriali" :items-per-page="-1"
                    hide-default-footer height="500" fixed-header show-select v-model="righeSelezionate"
                    item-key="IdMateriale" :search="search" mobile-breakpoint="0">
                    <template v-slot:item.QtaDaDeclassare="{ item }">
                        <v-text-field v-model.number="item.QtaDaDeclassare" type="number" density="compact" hide-details
                            min="0" :max="item.QtaOriginale" style="width: 90px" @input="controllaQuantita(item)"
                            v-if="!mostraMisure(item)" />

                        <v-text-field v-else v-model.number="item.PezziDaDeclassare" type="number" density="compact"
                            hide-details min="0" :max="item.PezziOriginali" style="width: 90px"
                            @input="controllaQuantita(item)" />
                    </template>
                    <template v-slot:item.UM="{ item }">
                        <span v-if="mostraMisure(item)">Pezzi</span>
                        <span v-else>{{ item.UM }}</span>
                    </template>
                    <template v-slot:item.QtaOriginale="{ item }">
                        <span v-if="!mostraMisure(item)">{{ Math.round(item.QtaOriginale * 1000) / 1000 }}</span>
                        <span v-else>{{ Math.round(item.PezziOriginali * 1000) / 1000 }}</span>
                    </template>
                    <template v-slot:item.DataConsumo="{ item }">
                        <v-text-field v-model="item.DataConsumo" type="date" density="compact" hide-details />
                    </template>
                </v-data-table>

            </v-card-text>

            <v-card-actions>
                <v-btn color="primary" @click="apriDialogStorico()">
                    <v-icon small class="mr-2">manage_history</v-icon>visualizza storico</v-btn>
                <v-spacer />
                <v-btn @click="chiudiDialog">Chiudi</v-btn>
                <v-btn color="primary" @click="salvaDati">Salva</v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog v-model="dialogStorico">
            <v-card>
                <v-card-title class="headline">
                    <v-col>
                        <v-row>
                            Storico declassamento
                            <v-spacer />
                            <v-btn icon @click="chiudiStorico()">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-row>
                        <v-row>
                            <v-spacer />
                            <v-text-field v-model="searchStorico" append-icon="search" label="Cerca" single-line
                                clearable />
                            <v-btn icon @click="caricaStorico()" class="ml-2 mt-4">
                                <v-icon>refresh</v-icon>
                            </v-btn>
                        </v-row>
                    </v-col>
                </v-card-title>
                <v-card-text>
                    <v-data-table :headers="headersStorico" :items="datiStorico" fixed-header :items-per-page="-1"
                        height="500" no-data-text="Nessun dato disponibile" hide-default-footer :search="searchStorico">
                        <template v-slot:item.QtaDaDeclassare="{ item }">
                            <v-text-field v-model.number="item.QtaDaDeclassare" type="number" density="compact"
                                hide-details min="0" :max="item.QtaOriginale" style="width: 90px"
                                @input="controllaQuantitaStorico(item)" />
                        </template>

                        <template v-slot:item.Azioni="{ item }">
                            <v-btn icon @click="eliminaElemento(item)"><v-icon>delete</v-icon></v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn @click="chiudiStorico">Chiudi</v-btn>
                    <!-- <v-btn color="primary" @click="salvaStorico()">Salva</v-btn> -->
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>

import { get_materiali_consumo, salva_declassamento, get_storico_declassamento, salva_storico_declassamento } from '@/api/api.registroSintesiPEFC.js'

export default {
    props: {
        dialog: { type: Boolean, default: false },
        compCode: { type: String, default: '' },
    },

    data() {
        return {
            elencoMateriali: [],
            headersMateriali: [
                { text: "CategoriaPEFC", value: "GruppoCategoriaPEFC" },
                { text: "Fornitore", value: "Fornitore" },
                { text: "DDT", value: "NBollaText" },
                { text: "Descrizione", value: "Descrizione" },
                { text: "Quantità totale magazzino", value: "QtaOriginale" },
                { text: "Quantità da declassare", value: "QtaDaDeclassare" },
                { text: "UM", value: "UM" },
                { text: "Data", value: "DataConsumo" },
            ],

            righeSelezionate: [],

            dialogStorico: false,

            datiStorico: [],
            headersStorico: [
                { text: "CategoriaPEFC", value: "GruppoCategoriaPEFC" },
                { text: "Fornitore", value: "Fornitore" },
                { text: "DDT", value: "NBollaText" },
                { text: "Descrizione", value: "Descrizione" },
                { text: "Quantità declassata", value: "QtaDaDeclassare" },
                { text: "Data declassamento", value: "DataConsumoIT" },
                { text: "Azioni", value: "Azioni" },],
            search: "",
            searchStorico: "",
        }
    },

    methods: {
        chiudiDialog(salva = false) {
            this.$emit("close", salva);
        },

        async caricaDati() {
            this.righeSelezionate = [];
            let par = "";
            if (this.role === "admin")
                par = "?companyCode=" + this.compCode;

            let res = await get_materiali_consumo(par);
            this.elencoMateriali = res.data;

            this.elencoMateriali = this.elencoMateriali.filter(item => item.QtaOriginale > 0);
        },

        async salvaDati() {
            if (this.righeSelezionate.length <= 0) {
                this.$toast.alert("Attenzione. Nessuna riga selezionata")
                return;
            }
            let righeDaSalvare = this.righeSelezionate.filter(item =>
                this.mostraMisure(item) ? item.PezziDaDeclassare > 0 : item.QtaDaDeclassare > 0
            );

            righeDaSalvare.forEach(el => {
                if (!el.DataConsumo) el.DataConsumo = new Date().toISOString().substring(0, 10);
            });

            let res = await salva_declassamento(righeDaSalvare);
            if (res.data == "OK") this.chiudiDialog();
            else this.$toast.alert(res.data);
        },

        controllaQuantita(item) {
            if (!this.mostraMisure(item)) {
                if (item.QtaDaDeclassare > item.QtaOriginale) {
                    item.QtaDaDeclassare = item.QtaOriginale;
                }
                if (item.QtaDaDeclassare < 0) {
                    item.QtaDaDeclassare = 0;
                }
            }
            else {
                if (item.PezziDaDeclassare > item.PezziOriginali) {
                    item.PezziDaDeclassare = item.PezziOriginali;
                }
                if (item.PezziDaDeclassare < 0) {
                    item.PezziDaDeclassare = 0;
                }
            }
        },

        mostraMisure(item) {
            return (item) &&
                ((item.GruppoCategoriaPEFC == '030000' ||
                    item.GruppoCategoriaPEFC == '030102' ||
                    item.GruppoCategoriaPEFC == '040200' ||
                    item.GruppoCategoriaPEFC == '040300'
                ))
        },

        apriDialogStorico() {
            this.dialogStorico = true;
            this.caricaStorico();
        },

        async caricaStorico() {
            let par = "";
            if (this.role === "admin")
                par = "?companyCode=" + this.compCode;
            let res = await get_storico_declassamento(par);
            this.datiStorico = res.data;
        },

        controllaQuantitaStorico(item) {
            if (item.QtaDaDeclassare > item.QtaOriginale) item.QtaDaDeclassare = item.QtaOriginale;
            this.salvaPosizione(item);
        },

        async salvaPosizione(elemento) {
            let res = await salva_storico_declassamento(elemento, "post");
            if (res.data != "OK")
                this.$toast.alert(res.data);
        },

        async eliminaElemento(elemento) {
            let confirm = await this.$confirm.open("Elimina", "Eliminare l'elemento?");
            if (!confirm) return;
            let res = await salva_storico_declassamento(elemento, "delete");
            if (res.data != "OK")
                this.$toast.alert(res.data);
            else {
                this.caricaStorico();
                this.caricaDati();
            }
        },

        chiudiStorico() {
            this.dialogStorico = false;
        },
    },

    watch: {
        dialog(newVal) {
            if (newVal) this.caricaDati();
        },
    },

    computed: {
        role() {
            return this.$store.getters['user/getRole'];
        },
    }
}
</script>
<style scoped>
/* usare ::v-deep per raggiungere elementi figli fuori dallo scope */
::v-deep .v-data-table__selected {
    background-color: #e7d1d6 !important;
    /* sfondo */
    transition: background-color 0.2s ease;
}

::v-deep .v-data-table__selected td {
    color: #30181f !important;
    /* colore testo */
}
</style>